import React from "react";

import Button from "@mui/material/Button";

import useAuth from "@app/common/auth/useAuth";
import useLocalStorage from "@app/common/hooks/useLocalStorage";
import useResponsiveView from "@app/common/hooks/useResponsiveView";
import LINKS from "@app/common/links";
import * as PolicyUtils from "@app/common/utils/policyUtils";

import AlertBanner, { AlertBannerProps } from "@rui/AlertBanner";
import Link from "@rui/Link";

const UpdatedPolicyBanner = ({
  direction,
}: {
  direction?: AlertBannerProps["direction"];
}) => {
  const { user } = useAuth();
  const { inMobileView } = useResponsiveView();

  const [bannerDismissed, setBannerDismissed] = useLocalStorage(
    "updatedPrivacyPolicyBannerDismissed",
    false
  );

  const shouldShowBanner =
    !bannerDismissed && PolicyUtils.userShouldBeNotifiedOfNewPolicies(user);

  if (!shouldShowBanner) return null;

  const effectiveDate = PolicyUtils.NEW_POLICY_EFFECTIVE_DATE.toLocaleString({
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  const handleDismissBanner = () => setBannerDismissed(true);

  return (
    <AlertBanner
      direction={inMobileView && !direction ? "column" : direction}
      severity="info"
      title="Notice"
      action={
        <Button
          variant="contained"
          onClick={handleDismissBanner}
          sx={{ height: "auto" }}
        >
          Got it
        </Button>
      }
    >
      Read AI's{" "}
      <Link href={LINKS.MARKETING.UPDATED_TERMS_OF_SERVICE}>
        Terms of Service
      </Link>{" "}
      and{" "}
      <Link href={LINKS.MARKETING.UPDATED_PRIVACY_POLICY}>Privacy Policy</Link>{" "}
      have been updated and will become effective {effectiveDate}.
    </AlertBanner>
  );
};

export default UpdatedPolicyBanner;
